import { globalEntitlements } from './globalEntitlements';

// Service name constants
const BASIC = 'worry_free_service_basic';
const STANDARD = 'worry_free_service';
const ADVANCED = 'worry_free_service_advanced';
const ADVANCED_ADDON = 'worry_free_service_advanced_addon';

/**
 * Gets the appropriate WFC Services buy button configuration using globalEntitlements builder
 * @param {...any} args
 * @returns {object} - Buy button configuration object
 */
export const getWfcServicesBuyButtonConfig = (...args) => {
  const [, serviceCode] = args;
  const serviceToButtonText = {
    [BASIC]: 'productPage.wfcServices.buyBox.buttonLabel1',
    [STANDARD]: 'productPage.wfcServices.buyBox.buttonLabel2',
    [ADVANCED]: 'productPage.wfcServices.buyBox.buttonLabel3',
  };

  const ctaText = serviceToButtonText[serviceCode] || serviceToButtonText[BASIC];

  const blockingRules = {
    [BASIC]: [BASIC, STANDARD, ADVANCED, ADVANCED_ADDON],
    [STANDARD]: [STANDARD, ADVANCED, ADVANCED_ADDON],
    [ADVANCED]: [STANDARD, ADVANCED, ADVANCED_ADDON],
  };

  const builder = globalEntitlements({ ctaText }).blockedByRelatedServices(blockingRules[serviceCode] || []);

  return builder.build()(...args);
};
